//#region import
import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import { FnAxios, I18n } from "utilities/utilities";
import AccordionCustom from "components/Accordion";
import FileAttach from "./Component/FileAttach";
import ChildrenItem from "./Component/ChildrenItem";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
//#endregion
const PublishedDocuments = () => {
  const navigate = useNavigate();
  const AxiosFn = FnAxios();
  const location = useLocation();
  const searchParams = location.search;
  const sID = new URLSearchParams(searchParams).get("sID");

  const [arrPublishDoc, setArrPublishDoc] = useState([] as IPublishDocItem[]);


  const GetPublishDoc = () => {
    AxiosFn.Post(`PublishDocFront/GetPublishDoc`, { sID: sID }, (result) => {
      setArrPublishDoc(result.lstPublishDoc);
    });
  };

  useEffect(() => {
    GetPublishDoc();
  }, [sID]);

  return (
    <Grid container alignItems="center" spacing={2}>
      {arrPublishDoc.length > 0 ? (
        <>
          {arrPublishDoc.map((item) => {
            return (
              <Grid item xs={12} md={12} key={item.nPublishedDocumentsID}>
                <AccordionCustom
                  header={item.sTitle}
                  isExpanded={false}
                  bgColor="rgb(102,151,245)"
                  background="linear-gradient(90deg, rgb(13 51 124) 0%, rgb(32 114 162) 100%)"
                  expandIconColor="#ffffff"
                  borderColor="white"
                  borderRadius="25px !important"
                  boxShadowHead="-5px 1px 25px -13px rgba(0,0,0,0.96)"
                  boxShadowDetail="1px 7px 25px -3px rgba(0,0,0,0.55)"
                >
                  {item.lstAttachFile.length > 0 ||
                  item.lstChlidren.length > 0 ? (
                    <Grid container spacing={2}>
                      {item.lstAttachFile.map((iF) => (
                        <FileAttach
                          key={"F_" + iF.sFileNameCover}
                          sFilePathCover={iF.sFilePathCover}
                          sDocumentName={iF.sDocumentName}
                          sDocDate={iF.sDocDate}
                          sFilePath={iF.sFilePath}
                        />
                      ))}

                      {item.lstChlidren.map((iF) => (
                        <ChildrenItem
                          key={"C_" + iF.sID}
                          sTitle={iF.sTitle}
                          sID={iF.sID}
                        />
                      ))}
                    </Grid>
                  ) : (
                    <Grid
                      item
                      xs={12}
                      container
                      flexDirection={"row"}
                      justifyContent={"center"}
                    >
                      <Typography>{`${I18n.SetText(
                        "PublishDoc.sNoData"
                      )}`}</Typography>
                    </Grid>
                  )}
                </AccordionCustom>
              </Grid>
            );
          })}
          {sID && (
            <Grid item mt={2}>
              <Button
                variant="contained"
                sx={{
                  bgcolor: "#758290",
                  color: "white",
                  borderRadius: "20px",
                  width: "8rem",
                }}
                startIcon={<ArrowBackIosIcon />}
                onClick={() => navigate(-1)}
              >
                {`${I18n.SetText("PublishDoc.sBack")}`}
              </Button>
            </Grid>
          )}
        </>
      ) : (
        <Grid item xs={12}>
          <Box minHeight={"600px"} textAlign={"center"}>
            {`${I18n.SetText("PublishDoc.sNoPublishDoc")}`}
          </Box>
        </Grid>
      )}
    </Grid>
  );
};
export default PublishedDocuments;

export interface IPublishDocItem {
  nPublishedDocumentsID?: any;
  sTitle?: string;
  lstAttachFile?: any;
  lstChlidren?: any;
}
